// French labels shared by the attestation admin screens (types, statuses, jury).
import { AttestationType, RequestStatus } from '../../../../types/student-requests.types';

export const ATTESTATION_TYPE_LABELS: Record<AttestationType, string> = {
  [AttestationType.PRE_INSCRIPTION]: 'Attestation de Pré-inscription',
  [AttestationType.ATTESTATION_SCOLARITE]: 'Attestation de Scolarité',
  [AttestationType.RELEVE_NOTES_ANNUEL]: 'Relevé de Notes Annuel',
  [AttestationType.ATTESTATION_REUSSITE]: 'Attestation de Réussite',
  [AttestationType.ATTESTATION_INSCRIPTION]: "Attestation d'Inscription",
  [AttestationType.CERTIFICAT_ASSIDUITE]: "Certificat d'Assiduité",
  [AttestationType.RELEVE_NOTES_SEMESTRIEL]: 'Relevé de Notes Semestriel',
  [AttestationType.ATTESTATION_STAGE]: 'Attestation de Stage',
  [AttestationType.CONVENTION_STAGE]: 'Convention de Stage',
};

export const getTypeLabel = (type: string): string =>
  ATTESTATION_TYPE_LABELS[type as AttestationType] ?? type;

export interface StatusBadgeStyle {
  label: string;
  color: string;
}

export const REQUEST_STATUS_BADGES: Record<RequestStatus, StatusBadgeStyle> = {
  [RequestStatus.DRAFT]: { label: 'Brouillon', color: 'bg-gray-100 text-gray-700' },
  [RequestStatus.PENDING_FINANCE]: { label: 'En attente Finance', color: 'bg-yellow-100 text-yellow-700' },
  [RequestStatus.PENDING_ACADEMIC]: { label: 'En attente Académique', color: 'bg-blue-100 text-blue-700' },
  [RequestStatus.FINANCE_APPROVED]: { label: 'Finance approuvée', color: 'bg-green-100 text-green-700' },
  [RequestStatus.ACADEMIC_APPROVED]: { label: 'Académique approuvée', color: 'bg-green-100 text-green-700' },
  [RequestStatus.APPROVED]: { label: 'Approuvée', color: 'bg-green-100 text-green-700' },
  [RequestStatus.GENERATED]: { label: 'Prête à collecter', color: 'bg-teal-100 text-teal-700' },
  [RequestStatus.DOWNLOADED_FOR_PRINT]: { label: 'Téléchargée pour impression', color: 'bg-purple-100 text-purple-700' },
  [RequestStatus.PRINTED]: { label: 'Imprimée', color: 'bg-indigo-100 text-indigo-700' },
  [RequestStatus.DELIVERED]: { label: 'Délivrée', color: 'bg-blue-100 text-blue-700' },
  [RequestStatus.REJECTED_FINANCE]: { label: 'Rejetée Finance', color: 'bg-red-100 text-red-700' },
  [RequestStatus.REJECTED_ACADEMIC]: { label: 'Rejetée Académique', color: 'bg-red-100 text-red-700' },
  [RequestStatus.CANCELLED]: { label: 'Annulée', color: 'bg-gray-100 text-gray-700' },
};

export const getStatusBadge = (status: RequestStatus): StatusBadgeStyle =>
  REQUEST_STATUS_BADGES[status] ?? { label: status, color: 'bg-gray-100 text-gray-700' };

/** Label shown when the jury has not deliberated on the student-year. */
export const NO_JURY_DECISION_LABEL = 'Non délibéré';
